import { render, staticRenderFns } from "./editor_right.vue?vue&type=template&id=0acd32ac"
import script from "./editor_right.vue?vue&type=script&lang=js"
export * from "./editor_right.vue?vue&type=script&lang=js"
import style0 from "./editor_right.vue?vue&type=style&index=0&id=0acd32ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports